import script from "./Description.vue?vue&type=script&setup=true&lang=ts"
export * from "./Description.vue?vue&type=script&setup=true&lang=ts"

import "./Description.vue?vue&type=style&index=0&id=0736404e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_vue@3.3.11_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0736404e"]])

export default __exports__